import React from "react";
import { Query } from "react-apollo";
import { GET_USER } from "../../../../graphql";
import ProfileBanner from "../../../UI/Profile/Banner";
import ProfileEntry from "../../../UI/Profile/Entry";
import {Link} from "react-router-dom"

const Container = ({userID,isOwn, ...rest}) => (
  <Query query={GET_USER} variables={{userID}} >
    {({ loading, error, data }) => {
      if(loading) return <p>Loading...</p>;
      if(error) return <p>Error :(</p>;

      if(data.getUser){
        const {id,firstName,lastName,email, studies, characteristics, avatarUrl} = data.getUser

        let lastStudy
        if(studies && studies.length){
          lastStudy = studies.reduce((last,current)=>last.endYear > current.endYear ? last : current)
        }

        let briefCharacteristics = []
        if(characteristics){
          briefCharacteristics = characteristics.slice(0,3)
        }
        
        return (
          <ProfileBanner firstName={firstName} lastName={lastName} url={avatarUrl}  {...rest}>
            <ProfileEntry icon="Location">Amsterdam</ProfileEntry>
            {}<ProfileEntry icon="Mail">{email}</ProfileEntry>
            {lastStudy ? <ProfileEntry icon="Language">{ `${lastStudy.studies}` }</ProfileEntry> : "" }             
            {briefCharacteristics.map(({id,name})=>(<ProfileEntry key={id}>{name}</ProfileEntry>))}
            {isOwn ? (<ProfileEntry icon="Edit"><Link to={`/profile`} >Edit profile</Link></ProfileEntry>) : (<ProfileEntry icon="Share"><Link to={`/profile/${id}`} >See profile</Link></ProfileEntry>)}
          </ProfileBanner>
      );
      }
        
      
    }}
  </Query>
);

export default Container;